import React, { useEffect, useRef } from 'react';

const AdSense = ({ 
  adSlot = "1234567890", 
  adFormat = 'auto', 
  fullWidthResponsive = true,
  style = {},
  className = '',
  uniqueKey = ''
}) => {
  const adRef = useRef(null);
  const hasAdLoaded = useRef(false);

  useEffect(() => {
    try {
      // Only push ad if it hasn't been loaded yet and the element exists
      if (adRef.current && !hasAdLoaded.current) {
        // Check if adsbygoogle is available
        if (typeof window !== 'undefined' && window.adsbygoogle) {
          // Check if this specific ad element already has ads
          const existingAds = adRef.current.querySelectorAll('.adsbygoogle');
          const hasExistingAds = Array.from(existingAds).some(ad => 
            ad.getAttribute('data-adsbygoogle-status') === 'done'
          );

          if (!hasExistingAds) {
            try {
              (window.adsbygoogle = window.adsbygoogle || []).push({});
              hasAdLoaded.current = true;
              console.log(`AdSense ad loaded: ${adSlot} (${uniqueKey})`);
            } catch (pushError) {
              console.error('AdSense push error:', pushError);
            }
          }
        } else {
          console.warn('AdSense script not loaded yet');
        }
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, [adSlot, uniqueKey]);

  // Reset when component unmounts or key changes
  useEffect(() => {
    return () => {
      hasAdLoaded.current = false;
    };
  }, [uniqueKey]);

  // Determine display style based on ad format
  const getDisplayStyle = () => {
    switch (adFormat) {
      case 'vertical':
        return 'block';
      case 'horizontal':
        return 'block';
      case 'rectangle':
        return 'inline-block';
      default:
        return 'block';
    }
  };

  return (
    <div 
      ref={adRef}
      className={`adsense-container ${className}`} 
      style={style}
      key={`adsense-${adSlot}-${uniqueKey}`}
    >
      <ins
        className="adsbygoogle"
        style={{ 
          display: getDisplayStyle(),
          ...style 
        }}
        data-ad-client="ca-pub-8417451713900552"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive}
      />
    </div>
  );
};

export default AdSense; 